import React from 'react';

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19" { ...props }>
    <path d="M15.34 1.9c1 0 1.93.41 2.64 1.14 1.5 1.56 1.5 4.1 0 5.66L16.8 9.93l-6.29 6.55-6.3-6.55L3.02 8.7c-1.5-1.56-1.5-4.1 0-5.66.71-.73 1.65-1.14 2.64-1.14s1.94.41 2.65 1.14l1.18 1.23 1.01 1.05 1.01-1.05 1.18-1.23a3.68 3.68 0 012.65-1.14m0-1.4c-1.32 0-2.64.52-3.65 1.57L10.5 3.3 9.32 2.07C8.31 1.02 6.99.5 5.66.5s-2.64.52-3.65 1.57C0 4.17 0 7.57 2.01 9.67L3.2 10.9l7.3 7.6 7.3-7.6 1.18-1.23c2.02-2.1 2.02-5.5 0-7.6-1-1.05-2.32-1.57-3.64-1.57z" />
  </svg>
);
